import { render, staticRenderFns } from "./MyCollectionSnapshot.vue?vue&type=template&id=6538443e&scoped=true&"
import script from "./MyCollectionSnapshot.vue?vue&type=script&lang=js&"
export * from "./MyCollectionSnapshot.vue?vue&type=script&lang=js&"
import style0 from "./MyCollectionSnapshot.vue?vue&type=style&index=0&id=6538443e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6538443e",
  null
  
)

export default component.exports